import { proxy } from 'src/core/classes/helpers/UrlHelper'
import { CORE_FORM } from 'src/core/constants'

export const getBaseUrl = (formId: number, code: string) => {
  return proxy(`/form/data-set-provider/v3/${formId}/${code}/kendo/data/search`)
}

export const getProcedureUrl = (procedureName: string) => {
  return proxy(`/webservice/${CORE_FORM.proceduresForm.id}/sp/v4/${procedureName}/call`)
}
